import { setAuth, getAuth, clearAuth } from './CookiesHelper';

let user;

export function getUserData() {
	return user || readUserData() || false;
}

function readUserData() {
	user = JSON.parse(localStorage.getItem("user"));
	return user;
}

function setUserData(data) {
	user = data;
	writeUserData(data);
}

function writeUserData(data) {
	localStorage.setItem("user", JSON.stringify(data));
}

function deleteAllUserData() {
	localStorage.clear();
}

export function loginUser(data) {
	setAuth(data.token);
	delete data.token;
	setUserData(data);
}

export function logoutUser() {
	deleteAllUserData();
	clearAuth();
}

export function isLoggedIn() {
	return (getAuth() && getUserData());
}

export function updateUserData(newData) {
	if(newData.token) {
		setAuth(newData.token);
		delete newData.token;
	}
	setUserData(Object.assign(getUserData(), newData));
}

export function prettyBalance() {
	const balance = +getUserData().balance;
	return `${balance.toFixed(2)} XCTR`;
}


// WEBPACK FOOTER //
// /opt/build/repo/src/utils/UserManager.js